/**
 *
 * Description:
 * This file defines two React functional components:
 * 1. `DatePickerInput` - A reusable date picker input component with configurable props including validation,
 *    min/max dates, clearable actions, and error handling. It uses `@mui/x-date-pickers` and Moment.js.
 * 2. `ScheduleDatePickerInput` - A lighter version of the date picker used specifically for scheduling
 *    purposes. Uses `onChange` instead of `onAccept`.
 *
 */
import React from "react";
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from "moment";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import './date-picker.scss'
import _ from 'lodash'

export default function DatePickerInput({ label, placeholder, maxDate, disabled, className = '', required, error, clearable = true, validation = [], minDate, dataCy = '', ...props }) {
    let isRequired = required || (validation.includes('required') && !(validation.includes('skip') || validation.includes('optional')));

    return (
        <div className="form-group">
            <div className={_.uniq(["input-block", "datepicker-block", ...className.split(' ')]).join(' ')}>
                <span className="input-icon icon-grey"><CalendarMonthIcon /></span>
                <label className="input-label">
                    <span>{label || placeholder || ''} {isRequired ? <span className='text-danger'>*</span> : null}</span>
                </label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                        id={props.name}
                        name={props.name}
                        data-cy={dataCy || props['data-cy'] || 'date-picker'}
                        margin='dense'
                        inputVariant='outlined'
                        value={moment.utc(props.value)}
                        format="DD/MM/YYYY"
                        // onChange={(value) => props.onChange(moment(value).toISOString())}
                        onAccept={(value) => props.onChange(moment(value).toISOString())}
                        maxDate={maxDate ? moment(maxDate) : null}
                        disabled={disabled}
                        slotProps={{
                            actionBar: {
                                actions: [...(clearable ? ['clear'] : []), 'cancel', 'accept']
                            },
                            textField: {
                                helperText: error ? <small className="float-start text-danger">{error}</small> : "",
                                error: error,
                                inputProps: {
                                    'data-cy': props['data-cy'] || undefined
                                }
                            },
                        }}
                        popperProps={props.popperProps}
                        minDate={minDate ? moment(minDate) : null}

                    />
                </LocalizationProvider>
            </div>
        </div >
    );
}


export function ScheduleDatePickerInput({ label, placeholder, maxDate, disabled, className = '', required, error, clearable = true, validation = [], dataCy = '', ...props }) {
    let isRequired = required || (validation.includes('required') && !(validation.includes('skip') || validation.includes('optional')));

    return (
        <div className="form-group">
            <div className={_.uniq(["input-block", "datepicker-block", ...className.split(' ')]).join(' ')}>
                <span className="input-icon icon-grey"><CalendarMonthIcon /></span>
                <label className="input-label">
                    <span>{label || placeholder || ''} {isRequired ? <span className='text-danger'>*</span> : null}</span>
                </label>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <MobileDatePicker
                        id={props.name}
                        data-cy={dataCy || props['data-cy'] || 'date-picker'}
                        margin='dense'
                        inputVariant='outlined'
                        value={moment.utc(props.value)}
                        format="DD/MM/YYYY"
                        onChange={(value) => props.onChange ? props.onChange(moment(value).toISOString()) : null}
                        onAccept={(value) => props.onAccept ? props.onAccept(moment(value).toISOString()) : null}
                        maxDate={maxDate ? moment(maxDate) : null}
                        disabled={disabled}
                        slotProps={{
                            actionBar: {
                                actions: [...(clearable ? ['clear'] : []), 'cancel', 'accept']
                            },
                            textField: {
                                helperText: error ? <small className="float-start text-danger">{error}</small> : "",
                                error: error,
                            },
                        }}

                    />
                </LocalizationProvider>
            </div>
        </div >
    );
}